"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFourPDAEvent = parseFourPDAEvent;
/**
 * Разбор push-сообщений с транспорта (`dispatchWireMessage` → `{ id, status, data }`).
 * Wire `30309`: `[30309, 0, channel, action, value?]` → data = [channel, action, value?].
 */
function parseFourPDAEvent(msg) {
    if (!msg || typeof msg !== 'object')
        return null;
    if (msg.id === 30309) {
        const data = msg.data;
        if (Array.isArray(data) && data.length >= 2) {
            const channel = data[0];
            const action = data[1];
            const value = data[2];
            if (typeof channel === 'string') {
                if (channel.startsWith('q')) {
                    const threadId = parseInt(channel.substring(1), 10);
                    if (action === 1) {
                        return {
                            type: 'qms_message',
                            threadId,
                            messageId: typeof value === 'number' ? value : undefined,
                            action: typeof action === 'number' ? action : undefined,
                            raw: msg,
                        };
                    }
                    if (action === 2) {
                        return {
                            type: 'qms_read',
                            threadId,
                            messageId: typeof value === 'number' ? value : undefined,
                            action: typeof action === 'number' ? action : undefined,
                            raw: msg,
                        };
                    }
                }
                else if (channel.startsWith('t')) {
                    const topicId = parseInt(channel.substring(1), 10);
                    return {
                        type: 'topic_update',
                        topicId,
                        action: typeof action === 'number' ? action : undefined,
                        raw: msg,
                    };
                }
                else if (channel.startsWith('s')) {
                    const articleId = parseInt(channel.substring(1), 10);
                    return {
                        type: 'site_update',
                        articleId,
                        action: typeof action === 'number' ? action : undefined,
                        messageId: typeof value === 'number' ? value : undefined,
                        raw: msg,
                    };
                }
                else if (channel.startsWith('f')) {
                    const forumId = parseInt(channel.substring(1), 10);
                    return {
                        type: 'forum_favorite_update',
                        forumId,
                        action: typeof action === 'number' ? action : undefined,
                        messageId: typeof value === 'number' ? value : undefined,
                        raw: msg,
                    };
                }
                else if (channel.startsWith('u') || channel.startsWith('g')) {
                    return {
                        type: 'user_update',
                        action: typeof action === 'number' ? action : undefined,
                        raw: msg,
                    };
                }
            }
        }
    }
    if (msg.id === 28773) {
        const data = msg.data;
        if (Array.isArray(data) && data.length >= 3) {
            const channel = data[0];
            const state = data[2];
            if (typeof channel === 'string' && channel.startsWith('q')) {
                const threadId = parseInt(channel.substring(1), 10);
                return {
                    type: 'qms_typing',
                    threadId,
                    state: state === 0 ? 'typing' : state === 1 ? 'uploading' : 'idle',
                    raw: msg,
                };
            }
        }
    }
    if (msg.id === 29285) {
        const data = msg.data;
        if (Array.isArray(data) && data.length >= 2) {
            const channel = data[0];
            const lastReadId = data[1];
            if (typeof channel === 'string' && channel.startsWith('q')) {
                const threadId = parseInt(channel.substring(1), 10);
                return {
                    type: 'qms_read',
                    threadId,
                    messageId: typeof lastReadId === 'number' ? lastReadId : undefined,
                    raw: msg,
                };
            }
        }
    }
    if (msg.id === 0 && msg.status === 0) {
        return { type: 'pong', raw: msg };
    }
    return { type: 'unknown', raw: msg };
}
